module.exports = __webpack_public_path__ + "static/redox_security_header_logo-06579a7698e7c689aacca8f55f2f76cb.svg";